// generated by the plop

import { UnknownError, UUID } from 'symbols';
import { TemplateExpectBackend } from '../../../pdf-templates/symbols';
import { TemplateGraphQLModel } from '../../../symbols';
import { InvoiceModel, InvoiceModelExpectBackend } from '../../symbols';

export class GetInvoiceById {
  static type = '[InvoiceManage] GetInvoiceById';

  constructor(public id: UUID) {
  }
}

export class GetInvoiceByIdSuccess {
  static type = '[InvoiceManage] GetInvoiceByIdSuccess';

  constructor(public invoice: InvoiceModel) {
  }
}

export class GetInvoiceByIdFail {
  static type = '[InvoiceManage] GetInvoiceByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentInvoiceId {
  static type = '[InvoiceManage] SetCurrentInvoiceId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalInvoice {
  static type = '[InvoiceManage] UpdateLocalInvoice';

  constructor(public invoice: InvoiceModel) {
  }
}

export class DeleteLocalInvoice {
  static type = '[InvoiceManage] DeleteLocalInvoice';

  constructor(public id: UUID) {
  }
}

export class UpdateInvoice {
  static type = '[InvoiceManage] UpdateInvoice';

  constructor(public id: UUID, public invoice: InvoiceModelExpectBackend, public force: boolean) {
  }
}

export class UpdateInvoiceSuccess {
  static type = '[InvoiceManage] UpdateInvoiceSuccess';

  constructor(public invoice: InvoiceModel) {
  }
}

export class UpdateInvoiceFail {
  static type = '[InvoiceManage] UpdateInvoiceFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateInvoice {
  static type = '[InvoiceManage] CreateInvoice';

  constructor(public invoice: InvoiceModelExpectBackend) {
  }
}

export class CreateWaybill {
  static type = '[InvoiceManage] CreateWaybill';

  constructor(public invoiceId: UUID) {
  }
}

export class CreateAcceptanceCertificate {
  static type = '[InvoiceManage] CreateAcceptanceCertificate';

  constructor(public invoiceId: UUID) {
  }
}

export class CreateServiceAgreement {
  static type = '[InvoiceManage] CreateServiceAgreement';

  constructor(public invoiceId: UUID) {
  }
}

export class CreatePurchaseAgreement {
  static type = '[InvoiceManage] CreatePurchaseAgreement';

  constructor(public invoiceId: UUID) {
  }
}

export class CreateInvoiceSuccess {
  static type = '[InvoiceManage] CreateInvoiceSuccess';

  constructor(public invoice: InvoiceModel) {
  }
}

export class CreateInvoiceFail {
  static type = '[InvoiceManage] CreateInvoiceFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateInvoiceTemplate {
  static type = '[InvoiceManage] CreateInvoiceTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}

export class UpdateInvoiceTemplate {
  static type = '[InvoiceManage] UpdateInvoiceTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteInvoiceTemplate {
  static type = '[InvoiceManage] DeleteInvoiceTemplate';

  constructor(public id: UUID) {
  }
}

export class UpdateInvoiceTemplateSuccess {
  static type = '[InvoiceManage] UpdateInvoiceTemplateSuccess';
}

export class UpdateInvoiceTemplateFail {
  static type = '[InvoiceManage] UpdateInvoiceTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetInvoiceTemplateList {
  static readonly type = '[InvoiceManage] GetInvoiceTemplateList';
}


export class CreateWaybillTemplate {
  static type = '[InvoiceManage] CreateWaybillTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}


export class UpdateWaybillTemplate {
  static type = '[InvoiceManage] UpdateWaybillTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteWaybillTemplate {
  static type = '[InvoiceManage] DeleteWaybillTemplate';

  constructor(public id: UUID) {
  }
}


export class UpdateWaybillTemplateFail {
  static type = '[InvoiceManage] UpdateWaybillTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetWaybillTemplateList {
  static readonly type = '[InvoiceManage] GetWaybillTemplateList';
}


export class CreateServiceCertificateTemplate {
  static type = '[InvoiceManage] CreateServiceCertificateTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}


export class UpdateServiceCertificateTemplate {
  static type = '[InvoiceManage] UpdateServiceCertificateTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteServiceCertificateTemplate {
  static type = '[InvoiceManage] DeleteServiceCertificateTemplate';

  constructor(public id: UUID) {
  }
}


export class UpdateServiceCertificateTemplateFail {
  static type = '[InvoiceManage] UpdateServiceCertificateTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetServiceCertificateTemplateList {
  static readonly type = '[InvoiceManage] GetServiceCertificateTemplateList';
}


export class CreateAcceptanceCertificateTemplate {
  static type = '[InvoiceManage] CreateAcceptanceCertificateTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}


export class UpdateAcceptanceCertificateTemplate {
  static type = '[InvoiceManage] UpdateAcceptanceCertificateTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeleteAcceptanceCertificateTemplate {
  static type = '[InvoiceManage] DeleteAcceptanceCertificateTemplate';

  constructor(public id: UUID) {
  }
}


export class UpdateAcceptanceCertificateTemplateFail {
  static type = '[InvoiceManage] UpdateAcceptanceCertificateTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetAcceptanceCertificateTemplateList {
  static readonly type = '[InvoiceManage] GetAcceptanceCertificateTemplateList';
}

export class CreatePurchaseAgreementTemplate {
  static type = '[InvoiceManage] CreatePurchaseAgreementTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}


export class UpdatePurchaseAgreementTemplate {
  static type = '[InvoiceManage] UpdatePurchaseAgreementTemplate';

  constructor(public template: TemplateGraphQLModel, public id: UUID) {
  }
}

export class DeletePurchaseAgreementTemplate {
  static type = '[InvoiceManage] DeletePurchaseAgreementTemplate';

  constructor(public id: UUID) {
  }
}


export class UpdatePurchaseAgreementTemplateFail {
  static type = '[InvoiceManage] UpdatePurchaseAgreementTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetPurchaseAgreementTemplateList {
  static readonly type = '[InvoiceManage] GetPurchaseAgreementTemplateList';
}
